import SelectLabel from './SelectLabel'

export default SelectLabel
